<div appFillHeight class="row justify-content-center">
  <div class="col-6">
    <markdown [data]="data"></markdown>
  </div>
</div>